<div class="generic-container-wrapper generic-container-wrapper--xl overlay-content">
    <i class="theme-error"></i>

    @if (messageData().title; as title) {
        <h2 class="generic-container-title">{{ title }}</h2>
    }
    @if (messageData().text; as text) {
        <p class="generic-container-text" [innerHTML]="text | trustAsHtml"></p>
    }
    @if (messageData().buttonText; as buttonText) {
        <div class="form-element btn-container">
            <button class="btn btn-secondary w-100" (click)="ok()">
                {{ buttonText }}
            </button>
        </div>
    }
</div>
